function initSearchField() {
    var $input = $('.b-search__input input'),
        $buffer = $('.b-search__input-buffer'),
        $tips = $('.b-search-tips');

    $($input)
        .on('input change focus', function () {
            $buffer.text($input.val());
            if ($buffer.width() == 0) {
                $input.width('auto');
            } else {
                $input.width($buffer.width());
            }
        })
        .on('focus', function () {
            $tips.show();
        })
        .on('blur', function () {
            $tips.hide();
        });
}
$(function () {
    initSearchField();
});

